// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3hOQU","upload":"Small_upload__Y13ES","imageWrap":"Small_imageWrap__TMhI3","removeBtn":"Small_removeBtn__Cd68j"};